module.exports = __webpack_public_path__ + "static/weatherupdate-6f576d3dc1c49cfadfc673abe1fe444c.png";